// Auto-generated translation for et.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:30:43.220755+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Hobuseomanikele",
    title: "Kõik oma hobuse jaoks. Ühes rakenduses.",
    subtitle: "Halda tervist, treeningut, planeerimist ja spetsialiste ühest selgest toimikust.",
    primaryCTA: {
      label: "Alusta tasuta",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Hobuse profiil — kaal, vaktsineerimine, EquiCoach, toitumine ja treening ühel ekraanil",
      caption: "Sinu hobune, täielik ülevaade.",
    },
    problem: "Tõenäoliselt hoiad kohtumisi, fotosid, treeningut, toitumist ja tervist praegu hajutatult — WhatsAppi gruppides, karpidesesse ja erinevates rakendustes. See takistab ülevaadet.",
    solution: "EquiSight loob sinu hobusest ühe täieliku digitaalse toimiku, mis käib sinuga kaasas.",
    benefits: [
      "Üks täielik hobuse profiil iga hobuse kohta",
      "Tervis, hobusesepp, hambaarst ja füsioterapeut ühes kohas",
      "Kalender nutikate meeldetuletustega",
      "Fotod, märkmed ja ajalugu ilma piiranguteta",
      "Kõigi andmete varukoopia Premium-is",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 hobune · alati tasuta",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Mitu hobust + varukoopia",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis alustama?",
      title: "Alusta täna oma esimese hobusega.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Rohkem hobuseid. Rohkem ülevaadet. Rohkem kindlust.",
    subtitle: "Uuenda Premium-ile ja halda kõiki oma hobuseid ilma piiranguteta — täieliku EquiCoach intelligentsiga.",
    primaryCTA: {
      label: "Alusta 14 päeva tasuta",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kõik hinnad",
      href: "/#pricing",
    },
    audience: "Omanikele, sportratsutajatele ja hobusepidajatele, kellel on mitu hobust.",
    features: [
      "Lisa piiramatu arv hobuseid",
      "Täielik ajalugu iga hobuse kohta",
      "Andmete varundamine",
      "Põhjalikud EquiCoach ülevaated",
      "Nutikad teavitused ja planeerimine",
      "Tervis ja treenimine täielikult seotud",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Vähem kui €0,17 päevas",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Uuenda Premium-ile.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Ratsutamiskooli ratsanikele",
    title: "Arene edasi, ka ilma oma hobuseta.",
    subtitle: "Jälgi oma tunde, treeninguid ja arengut EquiSight'is — vähem kui tassi kohvi eest kuus ema või isa jaoks. Või ühe toreda jäätise eest vahukoorega.",
    primaryCTA: {
      label: "Alusta Premiumiga",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kuidas see töötab?",
      href: "#features",
    },
    problem: "Ratsutamiskooли ratsanikuna pole sul sageli oma hobust, kuid soovid siiski areneda ja hoida ülevaadet oma tundidest, eesmärkidest ja hobustest, millega sõidad.",
    solution: "Ratsutamiskooli funktsionaalsus on Premiumis vaikimisi olemas — jälgi oma arengut ja vaata seotud ratsutamiskooli hobuseid kirjutuskaitstud režiimis.",
    features: [
      "Treeningute jälgimine",
      "Eesmärkide seadmine",
      "Progressi jälgimine",
      "Ratsutamiskooli hobuste vaatamine nime ja fotoga",
      "Ligipääs eraterviseandmetele puudub",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Kuus · ratsutamiskooli funktsionaalsus sisaldub",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Liitu",
      title: "Alusta ratsutamiskooli ratsanikuna.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Maneežidele ja tallidele",
    title: "Tee oma maneež igale ratsanikule digitaalselt kättesaadavaks.",
    subtitle: "Anna ratsanikele side hobuste, tundide ja arenguga — jagamata tundlikke talliandmeid.",
    primaryCTA: {
      label: "Taotle juurdepääsu",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata mooduleid",
      href: "#features",
    },
    audience: "EquiSight aitab maneežidel ja tallidel hoida ratsanikke kauem kaasatuna ning eristuda digitaalselt.",
    features: [
      "Maneežihobuste nähtavaks tegemine ratsanikele",
      "Nimi ja foto iga hobuse kohta",
      "Ratsanike sidumine hobustega",
      "Kirjutuskaitstud juurdepääs privaatsustundlikele andmetele",
      "Tundide ja treeningute ajalugu ühes kohas",
      "Kasutajahaldus rollidega",
    ],
    benefits: [
      "Tugevam side ratsanikega",
      "Professionaalsem maine",
      "Lisadigiteenus liikmetele",
      "Uus tuluvoog rakenduse kasutamise kaudu",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Kuus · maneežifunktsioon ratsanikele sisaldub",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktiveeri Maneežimoodul.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Aretusmoodul",
    title: "Kontroll tsükli, tiinuse ja varsa arengu üle.",
    subtitle: "Täielik aretusmoodul märaomanikele ja aretajatele — katvusest varsani, ühes ajajoones.",
    primaryCTA: {
      label: "Aktiveeri aretusmoodul",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata funktsioone",
      href: "#features",
    },
    audience: "Aretajatele, märaomanikele ja tallidele, kes haldavad mitut mära.",
    features: [
      "Tsükli jälgimine",
      "Innatsükli registreerimine",
      "Seemendusandmete salvestamine",
      "Loendus kuni ultraheliuuringuteni",
      "Tiinuskontrollide planeerimine",
      "Sugupuu ja päritolu",
      "Varsa areng",
      "Kõigi tiinete märade ülevaade",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Kuus · Aretusmoodul sisaldub Pro-paketis",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Alusta täna",
      title: "Alusta aretusjuhtimisega.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Kabjasepa moodul",
    title: "Tööta kabjasepana nutikamalt. Jäädvusta kõik professionaalselt.",
    subtitle: "Kalender, fotod, märkused ja raviajalugu ühes moodulis — vähem väärarusaamu, tugevam toimik.",
    primaryCTA: {
      label: "Alusta kabjasepana",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata Professional paketti",
      href: "/professional",
    },
    audience: "Kabjaseppadele, kes soovivad parandada ülevaadet, tõendamist ja kliendikommunikatsiooni.",
    features: [
      "Isiklik kalender",
      "Kohtumised kliendi kaupa",
      "Hobuste profiilide vaatamine",
      "Enne- ja järelpiltide lisamine",
      "Ravi ülesmärkimine",
      "Nõuannete ja märkuste jäädvustamine",
      "ETA teade kliendile: \"Kabjasepp on teel\"",
    ],
    benefits: [
      "Professionaalsem töö",
      "Vähem väärarusaamu",
      "Parem toimiku koostamine",
      "Tugevam vastutuse korral",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kuus · Kabjasepa moodul sisaldub Professional paketis",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktiveeri Kabjasepa moodul.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Hambaarsti moodul",
    title: "Täielik hambaravi toimik iga hobuse kohta.",
    subtitle: "Registreeri leiud, ravid ja järeltegevused otse EquiSight'is.",
    primaryCTA: {
      label: "Alusta hobusehambaarstina",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata Professional paketti",
      href: "/professional",
    },
    audience: "Hobusehambaarstid, veterinaararstid ja praktikad, kes soovivad töötada struktureeritult.",
    features: [
      "Hambauuringu registreerimine",
      "Leiud iga ravi kohta",
      "Fotode lisamine",
      "Aruanne omanikule",
      "Järelnõuanne",
      "Ajalugu iga hobuse kohta",
      "Uue kohtumise planeerimine",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kuus · Hambaarsti moodul sisaldub Professional paketis",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktiveeri hambaarsti moodul.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Füsio / Osteo moodul",
    title: "Jälgi keha, liikumist ja taastumist professionaalselt.",
    subtitle: "Füsioterapeutidele ja osteopaatidele, kes soovivad hobuseid süsteemselt juhendada.",
    primaryCTA: {
      label: "Alusta füsio/osteopaaadina",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata Professional paketti",
      href: "/professional",
    },
    features: [
      "Sissevõtt hobuse kohta",
      "Kehaleidude registreerimine",
      "Fotode ja videote lisamine",
      "Raviraporti koostamine",
      "Harjutuste ja järelkontrolli jagamine",
      "Taastumisraja jälgimine",
      "Ajalugu hobuse kohta",
    ],
    benefits: [
      "Parem ülevaade aja jooksul",
      "Professionaalne aruandlus",
      "Selge suhtlus omaniku, treeneri ja ratsutajaga",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kuus · Füsio / Osteo moodul on kaasas Professional paketis",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktiveeri Füsio / Osteo moodul.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Treeneri moodul",
    title: "Treeni ratsanikke andmete, eesmärkide ja edusammudega.",
    subtitle: "Muuda treenimine mõõdetavaks ja juhendamine professionaalsemaks — ühele või mitmele ratsanikule.",
    primaryCTA: {
      label: "Alusta treenerina",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata Pro paketti",
      href: "/#pricing",
    },
    audience: "Instruktoritele, treeneritele ja coachidele, kellel on mitu ratsanikku või hobust.",
    features: [
      "Ratsanike ühendamine",
      "Hobuste jälgimine",
      "Treeningeesmärkide seadmine",
      "Tagasiside andmine",
      "Võistlustulemuste analüüsimine",
      "Edusammude vaatamine kombinatsioonide kaupa",
      "Protokollianalüüside kasutamine treeningfookuse jaoks",
    ],
    benefits: [
      "Parem juhendamine",
      "Rohkem struktuuri",
      "Professionaalsem suhtlus",
      "Tugevam side klientidega",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Kuus · Treeneri moodul sisaldub Pro paketis",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Aktiveeri treeneri moodul.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Võistlusanalüüs",
    title: "Protokollist tulemuslikkuse parandamiseni.",
    subtitle: "Laadi üles oma võistlusprotokoll ja avasta, kus punkte kaotad — mitte ainult tulemuse vaatamine, vaid arusaamine, kuidas paremaks saada.",
    primaryCTA: {
      label: "Analüüsi oma esimest protokolli",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata Premium'i",
      href: "/premium",
    },
    features: [
      "Protokolli foto üleslaadimine",
      "Esikülg ja tagakülg töötlemine",
      "Klassi, katseprogrammi numbri ja kohtuniku tuvastamine",
      "Hindepunktide analüüs valdkonniti",
      "Kommentaaride kokkuvõte",
      "Tugevate ja nõrkade külgede näitamine",
      "Tendentsid hobune-ratsanik kombinatsiooni kaupa",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Kuus · võistlusanalüüs sisaldub alates Premium'ist",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Alusta võistlusanalüüsiga.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional pakett",
    title: "Hobusega töötavatele spetsialistidele.",
    subtitle: "Sepp, hambaarst, füsioterapeut, osteopaat või treener: tehke koostööd ühes digitaalses hobusedossieres.",
    primaryCTA: {
      label: "Alusta spetsialistina",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vaata eraldi mooduleid",
      href: "#features",
    },
    audience: "Professional pakett ühendab kõik erialarnoodulid üheks tellimuseks.",
    features: [
      "Sepa moodul",
      "Hambaarsti moodul",
      "Füsio / Osteo moodul",
      "Kalender ja kliendihaldus",
      "Hobuseprofiilid ja aruanded",
      "Ravihistooria ja dossierikoostamine",
      "Suhtlus omanikuga",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Kuus · kõik erimoodulid sisalduvad",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Valmis?",
      title: "Vali Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Hobuse hädaabinumbrid",
    title: "Õige abi on alati käeulatuses.",
    subtitle: "Hädaolukorras loeb iga sekund. EquiSight'iga on kõik sinu hobuse olulised kontaktandmed kohe käepärast — ühe puudutusega helistad.",
    primaryCTA: {
      label: "Sea oma hädakontaktid valmis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Alusta EquiSight'iga tasuta",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Hädakontaktid — helista, saada WhatsApp või navigeeri otse loomaarsti, kliiniku ja sepa juurde",
      caption: "Üks puudutus. Paanika otsimiseta.",
      embeddedFrame: true,
    },
    problem: "Sinu hobusega on midagi lahti — koolikud, vigastus, paanika. Ja siis algab otsimine. Keda helistada? Kas sul on õige number? Kas see on kiirabi number? Väärtuslik aeg läheb kaotsi.",
    solution: "EquiSight'iga on kõik kohe käepärast. Ei mingit otsimist. Ei mingit kahtlust. Ühe puudutusega saad ühenduse.",
    scenario: {
      title: "Kujuta ette — sinu hobusel ilmnevad koolikutunnused.",
      steps: [
        "Avad EquiSight'i",
        "Klikid \"Loomaarst\"",
        "Helistad otse",
      ],
      tagline: "Ei stressi. Ei otsimist. Ainult tegevus.",
    },
    features: [
      "Kõik hädaabinumbrid ühes kohas",
      "Ühe puudutusega helistamine rakendusest",
      "WhatsAppi saatmine ühe puudutusega",
      "Otse aadressile navigeerimine",
      "Igal hobusel oma kontaktinimekiri",
      "Loomaarst, kliinik, sepp, hambaarst, füsioterapeut",
      "Aadress + marsruudikirjeldus kohe saadaval",
      "Märgi lemmikud numbrid tärniga",
      "Kiirabi numbrid (112, 144) alati üleval",
    ],
    benefits: [
      "Rahu ja kontroll hädaolukorras",
      "Kõigil tallis on samad numbrid käepärast",
      "Ei unustatud visiitkaarte enam",
      "Reageeri kiiremini sekundite võrra",
    ],
    audience: "Hobuse omanikele, hooldajatele, treeneritele ja tallidele — kõigile, kes on hobuse eest vastutavad.",
    showcase: {
      eyebrow: "Eelnevalt sinu jaoks seadistatud",
      title: "13 kontaktikategooriat — täitmiseks valmis.",
      description: "Loomaarstist ja kiirkliinikust kuni sadulsepa, juhendaja ja karjamaahaldurini. EquiSight tunneb sinu maailma ja seab õiged kontaktiväljad sinu jaoks valmis. Puuduta, täida, valmis.",
      bullets: [
        "Hädaabi ja tervis — loomaarst, kiirabi, kliinik, mürgistusliin",
        "Igapäevane hooldus — sepp, hambaarst, füsioterapeut, juhendaja",
        "Tall ja karjamaa — tallipidaja, karjamaahaldur, pensionstall",
        "Sööt ja varustus — hein, jõusööt, allapanu tarnijad",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Hädakontaktide haldusekraan — kõik soovitatud kontaktid kategooriate kaupa",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Hobuse hädaabinumbrite kontrollnimekiri",
      items: [
        "Loomaarst",
        "Kiirkliinik (24/7)",
        "Loomaambulants · 144",
        "Sepp",
        "Varuühendusisik",
        "Üldine hädaabinumber · 112",
      ],
      cta: {
        label: "Ava EquiSight'is ja täida kohe",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Hädaabinumbrid",
          price: "Gratis",
          note: "Alati tasuta · kõigile, igas paketis",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Veendu, et oled valmis",
      title: "Enne kui seda vaja läheb.",
      href: "/#waitlist",
    },
    microcopy: [
      "Kohustusi pole",
      "Seadistatud 2 minutiga",
      "Alati muudetav",
    ],
  },
};

export default LANDINGS;
